import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	tableUserCellNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.users-and-roles.table.table-user-cell-non-final',
		defaultMessage: 'User',
		description: 'Transition home users and roles step table user cell',
	},
	tableUserCellActionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.users-and-roles.table.table-user-cell-action-non-final',
		defaultMessage: 'View profile',
		description: 'Transition home users and roles step table user cell action',
	},
});
